import styles from './PulsatingIcon.module.scss';

export const PulsatingIcon: React.FC = () => <span className={styles.circle} />;
